import React from 'react'
import NoContentStyled from './styles/no-content'

const NoContent = ({ children }) => {
  return <NoContentStyled>{children}</NoContentStyled>
}

export default NoContent
